export const UNKNOWN_BRAND_ID = 1667;
export const MAX_POPULAR_BRANDS = 5;
export const BRANDS_CACHE_STALE_TIME = 1000 * 60 * 60 * 24; // 24 hours
